<template>
  <v-content v-if="loading">
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>
    <!-- 确认框 -->
    <confirm ref="myConfirm"
             @clickFun="doClick"></confirm>

    <!-- 提示框 -->
    <confirm ref="myAlert"></confirm>

    <v-flex class="center-style">
      <v-flex class="content">
        <v-flex class="title">{{kbn==0?'新闻修改':'新闻添加'}}</v-flex>

        <v-row>
          <v-flex>
            <v-row>
              <v-row class="title-part">
                <v-card-title class="add-title"
                              primary-title>标题:</v-card-title>
                <v-text-field class="add-field"
                              name="login"
                              type="text"
                              v-model="fromProduct.productName"
                              :error="error"
                              :rules="[rules.required]" />

              </v-row>
              <v-row class="type">
                <v-card-title class="add-title"
                              primary-title>类型:</v-card-title>
                <v-select v-model="fromProduct.type"
                          :items="typeList"
                          item-text="typeName"
                          item-value="typeId"
                          dense
                          solo></v-select>
              </v-row>
            </v-row>

            <v-row>
              <v-card-title class="add-title"
                            primary-title>描述:</v-card-title>
              <v-textarea class="textarea-product"
                          autocomplete="描述"
                          v-model="fromProduct.productDesc"
                          :error="error"
                          :rules="[rules.required]"></v-textarea>
            </v-row>

            <v-row>
              <v-row class="images-part">
                <v-card-title class="add-title"
                              primary-title>照片:</v-card-title>

                <v-file-input filled
                              prepend-icon="mdi-camera"
                              @change="uploadImg"
                              accept="image/gif,image/jpeg, image/png, image/jpg"
                              :error="error"
                              :rules="[rules.required]"></v-file-input>
                <v-btn @click="previewImage = !previewImage"
                       style="height: 55px;">
                  <v-icon>{{previewImage?'fa fa-eye':'fa fa-eye-slash'}}</v-icon>
                </v-btn>
              </v-row>
              <img class="image"
                   v-show="previewImage"
                   v-if="fromProduct.photo"
                   :src="fromProduct.photo" />
            </v-row>

          </v-flex>

        </v-row>

        <!-- 富文本框 -->
        <v-flex class="product">
          <editor ref="myQuillEditor"
                  :content="fromProduct.productContent"></editor>
        </v-flex>

        <v-flex class="center-style"
                v-show="!addSuccess">
          <v-btn @click="click">{{kbn==0?'修改':'添加'}}</v-btn>
        </v-flex>
      </v-flex>
    </v-flex>
  </v-content>
</template>
<script>

import Loading from '@/components/core/Loading' //引入产品列表分页 api 接口

export default {
  components: { Loading },
  data () {
    return {
      loading: false,
      //查看添加标识
      kbn: 0,
      //项目类型
      typeList: [],
      //添加成功标识
      addSuccess: false,
      isLoading: false,
      productId: 0,
      previewImage: false,
      fromProduct: {
        //标题
        productName: "",
        //描述
        productDesc: "",
        //缩略图
        photo: "",
        //产品内容
        productContent: "",
        //修改时间
        updateTime: ""
      },
      //是否错误
      error: false,
      //错误提醒
      rules: {
        required: (value) => !!value || '必填项，不能为空'
      },
      dateDialog: false
    }
  },
  mounted () {
    this.kbn = this.$route.query.kbn;
    this.init();
  },
  methods: {

    //初期化
    init () {
      this.isLoading = true;
      this.$store
        .dispatch("GetProductTypes")
        .then(response => {
          this.typeList = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      if (this.kbn == 0) {
        this.getProduct(this.$route.query.productId)
      } else {
        this.loading = true;
      }

    },

    getProduct (id) {
      this.isLoading = true;
      this.$store
        .dispatch("GetProductById", id)
        .then(response => {
          this.fromProduct = response.data.data;
          this.isLoading = false;
          this.$nextTick(() => {
            this.loading = true;
          })

        })
        .catch(() => { this.isLoading = false; });
    },

    //添加图片
    uploadImg (e) {
      this.imageToBase64(e, true, function (val, obj) {
        obj.photo = val;
      }, this.fromProduct);
    },

    //添加产品
    addProduct () {
      this.isLoading = true;
      //修改时间暂存token
      this.fromProduct["updateTime"] = sessionStorage.token;
      this.$store.dispatch("AddProduct", this.fromProduct).then(response => {
        let result = response.data.data;
        let str = "";

        switch (result) {
          case 200:
            str = "添加成功!"
            break;
          case 401:
            str = "身份登陆过期，请重新登录!"
            break;
          case 500:
            str = "图片上传失败!"
            break;
          case 5001:
            str = "产品上传失败!"
            break;
          default:
            str = "添加失败!"
        }
        this.$refs.myAlert.show(str, {
          type: 'alert'
        })
        this.addSuccess = true;
        this.isLoading = false;
        this.init();
      })
        .catch(() => {
          this.isLoading = false;
        });
    },

    //修改产品
    updateProduct () {
      this.isLoading = true;
      //修改时间暂存token
      this.fromProduct["updateTime"] = sessionStorage.token;
      this.$store.dispatch("UpdateProduct", this.fromProduct).then(response => {
        let result = response.data.data;
        let str = "";
        switch (result) {
          case 200:
            str = "修改成功!"
            break;
          case 401:
            str = "身份登陆过期，请重新登录!"
            break;
          case 500:
            str = "图片上传失败!"
            break;
          case 5001:
            str = "产品上传失败!"
            break;
          default:
            str = "修改失败!"
        }
        this.$refs.myAlert.show(str, {
          type: 'alert'
        })
        this.isLoading = false;
        this.init();
      })
        .catch(() => {
          this.isLoading = false;
        });
    },

    //点击“修改”或者“添加”按钮
    click () {
      this.$refs.myConfirm.show(this.kbn == 1 ? "确认添加该产品" : "确认修改该产品？", {})
    },

    doClick () {
      //获取产品内容
      this.fromProduct.productContent = this.$refs.myQuillEditor.contentText;
      if (this.fromProduct.productName && this.fromProduct.productDesc && this.fromProduct.photo) {
        this.kbn == 1 ? this.addProduct() : this.updateProduct()
      }
      else {
        this.$refs.myAlert.show("请补全内容", {
          type: 'alert'
        })
        this.error = false;
      }

    },

    /**
* 
* @param {需要转换的图片file} file 
* @param {是否返回压缩后的base64} isCompression 
* @param {需要修改的对象} obj 
* @param {转换成功后通过回调函数将结果返回} callback 
*/
    imageToBase64 (file, isCompression, callback, obj) {
      // 判断图片类型
      var isJpg = false;
      if (file) {
        if (file.type == 'image/jpeg' || file.type == 'image/png' || file.type == 'image/jpg') {
          isJpg = true;
        } else {
          isJpg = false;
        }

        // 判断图片大小
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJpg) {
          this.$refs.myAlert.show("上传图片只能是jpg/png/jepg格式", {
            type: 'alert'
          });
        }
        if (!isLt2M) {
          this.$refs.myAlert.show("上传图片大小不能超过2M", {
            type: 'alert'
          });
        }

        // 创建一个HTML5的FileReader对象
        var reader = new FileReader()
        // 创建一个img对象
        var img = new Image()
        // let filename = file.filename
        if (file) {
          reader.readAsDataURL(file)
        }
        if (isJpg && isLt2M) {
          reader.onload = (e) => {
            // let base64Str = reader.result.split[','][1]
            img.src = e.target.result
            // base64地址图片加载完毕后执行
            img.onload = function () {
              // 缩放图片需要canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
              var canvas = document.createElement('canvas');
              var context = canvas.getContext('2d');
              // 图片原始尺寸
              var originWidth = this.width;
              var originHeight = this.height;
              // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
              var maxWidth = 580;
              var maxHeight = 250;
              // 目标尺寸
              var targetWidth = originWidth;
              var targetHeight = originHeight;
              // 图片尺寸超过最大尺寸限制
              if (originWidth > maxWidth || originHeight > maxHeight) {
                if (originWidth / originHeight > maxWidth / maxHeight) {
                  // 更改宽度，按照宽度限定尺寸
                  targetWidth = maxWidth;
                  targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                } else {
                  targetHeight = maxHeight;
                  targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                }
              }
              // 对图片进行缩放
              canvas.width = targetWidth;
              canvas.height = targetHeight;
              // 清除画布
              context.clearRect(0, 0, targetWidth, targetHeight)
              /** 图片压缩
               * 第一个参数是创建的img对象
               * 第二三个参数是左上角坐标
               * 后两个参数是画布区域宽高
               */
              context.drawImage(img, 0, 0, targetWidth, targetHeight)
              /** 压缩后的base64文件
               * 第一个参数可以为image/jpeg或image/webp类型的图片
               * 第二个参数设置图片质量取值0-1，超出则以默认值0.92替代
               */
              var newUrl = canvas.toDataURL('image/jpeg', 0.99)
              if (isCompression) { // 返回压缩后的base64
                callback(newUrl, obj)
              } else { // 返回不压缩的base64
                callback(e.target.result, obj)
              }
            }
          }
        }

      }
    },


  }
}
</script>

<style scoped>
.center-style {
  display: flex;
  justify-content: center;
  align-content: center;
}
.content {
  max-width: 1200px;
  overflow: auto;
}
.content >>> .row {
  margin: 0;
}
.title-part {
  width: 60%;
  max-width: 600px;
  margin: 0 30px 0 0;
}
.title {
  margin: 10px;
  font-size: 25px;
}
.textarea-product {
  margin: 30px;
}
.textarea-product >>> .v-text-field__slot {
  height: 100px;
  border: 2px inset rgb(240, 234, 234);
}
.type {
  flex: none;
  width: 360px !important;
  margin: 0;
}
.type >>> .v-input {
  margin-top: 10px;
}
.type >>> .v-input__slot {
  margin: 0;
}
.images-part {
  margin: 0;
  width: 450px;
  height: 56px !important;
  flex: none;
}
.image {
  width: 290px;
  height: 163px;
  margin: 30px;
  float: left;
}

.product {
  margin: 30px;
}
</style>